import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import how_it_works3 from "../images/how_it_works3.png"
import StartButton from "../Buttons/StartButton";

const useStyles = makeStyles({
  root: {
    maxWidth: 380,
    height: 650,
  },
  media: {
    height: 800,
  },
  responsive: {
    width: "100%",
    height: "auto",
  },
});

export default function Cardstep1() {
  const classes = useStyles();

  return (
    <Card className={classes.responsive}>
      <CardActionArea style={{height: "auto"}}>
        <CardContent>
          <Typography gutterBottom variant="h5" component="h1">
            Work-related pain & stress.
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p" style={{marginTop: 20}}>
            <p>
            For those with specific sports or recreational related injuries or complaints.<br/><br/>

            Have you acquired a sports injury and do you want to return safely to your sport? <br/><br/>
            After sustaining a sports injury, it is first and foremost important to get the injury evaluated by a healthcare professional that can give you the correct diagnosis and rule out serious pathology that requires urgent care.
            When you know your diagnosis it is time to begin your rehabilitation and hopefully make a comeback to your sport.<br/><br/>
              
            Returning to your sport after a sports injury requires a good rehabilitation protocol with the right amount of progression at the right time to ensure the best and safest return. This is often done gradually after the ladder principle of rehabilitation until a level is reached that matches the requirements of your sport.<br/><br/>
              
            After a sports injury, the tissue has reduced strength, capacity and function. It is vital for a good rehabilitation that the tissue strength, capacity and function of the injured body part has been regained and rebuilt to match closely to your pre-injury level before returning to sports. br/><br/>
              
            If a return to competitive sport is made before regained & rebuilding sufficient strength, capacity and function of the injured body part then there is a dramatically increased risk of re-injuring yourself during the following season.<br/><br/>
              
            Our Virtual Physiotherapy Assistant will screen your injury for signs of any acute or traumatic tissue injury that would require further medical examination and will let you know if you any of these signs. We will even write a small report of your symptoms and send you in the right direction for further evaluation. <br/><br/>
              
            Our virtual rehabilitation programs for sports injuries are built upon the concept of evidence-based practice, which ensures that you only receive advice and exercises that are proven to work and so that you are the right amount of progression at the right time!<br/><br/>
                
            All you need to do is to activate and start our Virtual Physiotherapist Assistant and complete our virtual assessment form then we will guide you step by step from there and help you get back to your best and return safely to your sport.<br/>
              
            </p><StartButton/><br/>
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Button size="small" color="primary">
          Share
        </Button>
        <Button size="small" color="primary">
          Learn More
        </Button>
      </CardActions>
    </Card>
  );
}
